import { FC, ReactNode } from 'react';

import { Heading, Paragraph } from '@purpur/library';
import { IllustrativeIconTechnicalErrorOffblackAnimated } from '@purpur/library/illustrative-icon/technical-error-offblack-animated';

import { Centered, IconContainer, NotFoundWrapper } from './NotFoundContent.styles';

type Props = { title: string; description: string; children?: ReactNode };

export const NotFoundContent: FC<Props> = ({ title, description, children }) => (
    <NotFoundWrapper>
        <IconContainer>
            <IllustrativeIconTechnicalErrorOffblackAnimated autoplay={false} aria-hidden="true" />
        </IconContainer>
        <Heading tag="h2" variant="title-300">
            {title}
        </Heading>
        <Paragraph variant="paragraph-100">
            <Centered>{description}</Centered>
        </Paragraph>
        {children}
    </NotFoundWrapper>
);
